export class TextLineMetrics {
    public ascent: number;
    public descent: number;
    public height: number;
    public leading: number;
    public width: number;
    public x: number;

    constructor(x: number = 0, width: number = 0, height: number = 0, ascent: number = 0, descent: number = 0, leading: number = 0) {
        this.ascent = ascent;
        this.descent = descent;
        this.height = height;
        this.leading = leading;
        this.width = width;
        this.x = x;
    }
}